import React, { useEffect, useState } from 'react';
import { BuscarDependentes, Buscas, buscarAssociado } from '../../services/dependentes';
import { FormDependentes } from './atom/FormDependentes.jsx';
import Context from './context/form-context';
import { calcularIdade, categoriasPossiveisPorPlano, removerDependentePetPlanosPermitidos } from './helpers/funcoesAuxiliares';
import { camposLimposFormDependentes } from './helpers/objetosAuxiliares';
import './styles.css';
import { buscarParentescoPorPlanoController } from './infraestrutura/infraestrutura.js';

const FormularioDependentes = ({
    inscricao,
    listaDependentes,
    subGrupo,
    setDependentes,
    idadeAssociado,
    codigoIbge,
    troca,
    subGrupoSelecionadoUpSell,
    handleValidationErrors
}) => {
    const plano = subGrupoSelecionadoUpSell || subGrupo;
    const [primeiroCarregamento, setPrimeiroCarregamento] = useState(true);
    const [state, setState] = useState({
        editar: false,
        idadeAssociado: calcularIdade(idadeAssociado),
        inscricao,
        parentesco: null,
        dependentes: listaDependentes,
        plano,
        categorias: null,
        temErroPorPlano: false,
        recarregarTabelaDependentes: false,
        cargaFormulario: camposLimposFormDependentes,
        arrayMsgsValidacoesPlano: [],
        objComparadorEdicao: null,
        codigoIbge,
        troca,
        subGrupoSelecionadoUpSell
    });

    useEffect(() => {
        (async () => {
            if (primeiroCarregamento) {
                const [responseParenstesco, responseDependentes, responseCategoria, responseAssociado] = await Promise.all([
                    await buscarParentescoPorPlanoController(plano.trim()),
                    await BuscarDependentes(inscricao, subGrupoSelecionadoUpSell),
                    await Buscas(`/categorias/${plano.trim()}/${codigoIbge}`),
                    await buscarAssociado(inscricao)
                ]);

                state.tipoCobranca = responseAssociado[0].AssTipoCobranca;

                let arrayVazioDependentes = false;

                if (!responseDependentes) {
                    arrayVazioDependentes = true;
                }

                const categoriasPorPlano = categoriasPossiveisPorPlano(
                    responseCategoria,
                    state.plano.trim()
                );
                const parentescosSemPetPorPlano =
                    state.plano.trim().substring(0, 4) !== 'ZPET' ?
                        removerDependentePetPlanosPermitidos(
                            responseParenstesco,
                            state.plano.trim(),
                            categoriasPorPlano
                        ) :
                        responseParenstesco.filter(
                            parentesco => parentesco.value.trim() === 'PET'
                        );

                setState({
                    ...state,
                    dependentes: arrayVazioDependentes ? [] : responseDependentes,
                    parentesco: parentescosSemPetPorPlano.map(parentesco => {
                        const valueSemEspaco = parentesco.value?.trim();

                        return {
                            ...parentesco,
                            value: valueSemEspaco
                        };
                    }),

                    categorias: categoriasPorPlano
                });
                setDependentes(arrayVazioDependentes ? [] : responseDependentes);
            }

            setPrimeiroCarregamento(false);
        })();
    }, [subGrupoSelecionadoUpSell]);

    useEffect(() => {
        (async () => {
            if (!state.recarregarTabelaDependentes) {
                return;
            }

            const responseDependentes = await BuscarDependentes(inscricao, subGrupoSelecionadoUpSell);

            let arrayVazioDependentes = false;

            if (!responseDependentes) {
                arrayVazioDependentes = true;
            }

            setState({
                ...state,
                dependentes: arrayVazioDependentes ? [] : responseDependentes,
                recarregarTabelaDependentes: false

            });
            setDependentes(arrayVazioDependentes ? [] : responseDependentes);
        })();
    }, [state.recarregarTabelaDependentes]);

    useEffect(() => {
        subGrupoSelecionadoUpSell && (handleValidationErrors(state.temErroPorPlano));
    }, [state.temErroPorPlano]);

    return (
        <>
            <Context.Provider value={{
                state,
                setState
            }}>
                <FormDependentes />
            </Context.Provider>

        </>
    );
};

export default FormularioDependentes;